// extracted by mini-css-extract-plugin
export default {"price":"E--z","onSale":"F--z","msrpLabelPrice":"G--z","msrpLabel":"H--z","originalPrice":"I--z","percentOff":"J--z"};